module.exports = __webpack_public_path__ + "img/add-subscription.fd026c0b.svg";